import { useMemo } from 'react';

import { FooterMenuColumn } from './types';

export const useFooterMenu = (ergeonUrl: string, projectsGalleryUrl?: string): FooterMenuColumn[] => {
  return useMemo(() => {
    const galleryUrl = projectsGalleryUrl || `${ergeonUrl}/gallery`;

    return [
      {
        title: 'Tools',
        items: [
          { label: 'Get a Quote', href: `${ergeonUrl}/request-quote` },
          { label: 'Fence Calculator', href: `${ergeonUrl}/fence-calculator` },
          { label: 'Gallery', href: galleryUrl },
        ],
      },
      {
        title: 'Company',
        items: [
          { label: 'About Us', href: `${ergeonUrl}/about` },
          { label: 'Careers', href: `${ergeonUrl}/careers` },
          { label: 'Help', href: `${ergeonUrl}/help` },
        ],
      },
      {
        title: 'Products',
        items: [
          { label: 'Fences', href: `${ergeonUrl}/fences` },
          { label: 'Gates', href: `${ergeonUrl}/gates` },
          { label: 'Driveways', href: `${ergeonUrl}/driveways` },
        ],
      },
    ];
  }, [ergeonUrl, projectsGalleryUrl]);
};
